import { render, staticRenderFns } from "./applicationTextbook.vue?vue&type=template&id=145b0b2a&scoped=true&"
import script from "./applicationTextbook.vue?vue&type=script&lang=js&"
export * from "./applicationTextbook.vue?vue&type=script&lang=js&"
import style0 from "./applicationTextbook.vue?vue&type=style&index=0&id=145b0b2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145b0b2a",
  null
  
)

export default component.exports